import ModuleTranslations from "../Conditions/ModuleTranslations";
import { getTranslatedDefinition } from "../utils";
import { messages, tickerValidator } from "../../globalVariables";
import { BASE_URL } from "../../request";
import { PAYMENT_TYPES_NAMES } from "../../Common/constants";
import { FormattedMessage } from "react-intl";
import React from "react";

/**
 * Created by mongoose on 8/11/17.
 */

const ModuleDefinition = {
  name: "Conditions",
  entityName: "conditions",
  restConfig: {
    baseURL: `${BASE_URL}`,
    create: {
      url: ({ propertyTicker }) => `api/backoffice/${propertyTicker}/conditions`,
      method: "post",
      resetCache: false,
    },
    update: {
      url: ({ propertyTicker }) => `api/backoffice/${propertyTicker}/conditions`,
      method: "put",
      resetCache: false,
    },
    fetch: {
      url: ({ propertyTicker, ticker }) =>
        `api/backoffice/${propertyTicker}/conditions/${ticker ? ticker : ""}`,
      method: "get",
    },
    delete: {
      url: ({ propertyTicker, ticker }) => `api/backoffice/${propertyTicker}/conditions/${ticker}`,
      method: "delete",
      resetCache: false,
    },
  },
  entities: [],
  allowClone: true,
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "translations",
    hasAdvancedTranslations: true,
  },
  relatedEntities: [
    {
      name: "cancellationPolicy",
    },
    {
      name: "paymentTypes",
    },
  ],
  fields: {
    list: [
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "name",
        displayName: "Nombre",
      },
      {
        fieldName: "earlyCharge",
        displayName: "%cobro",
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Cobrar primera noche",
      },
      {
        fieldName: "policies",
        displayName: "Política de Cancelación",
        widget: "arrayRenderer",
      },
      {
        fieldName: "payments",
        displayName: "Formas de cobro",
        widget: "arrayRenderer",
      },
      {
        fieldName: "minimumCharge",
        displayName: "Mínimo",
      },
      {
        fieldName: "color",
        displayName: "Color",
        widget: "colorView",
      },
    ],
    form: [
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
      },
      {
        fieldName: "code",
        widget: "hidden",
      },
      {
        fieldName: "type",
        widget: "hidden",
      },
      {
        fieldName: "ordering",
        widget: "hidden",
        defaultValue: 1,
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        className: "tickerInput",
        widget: "input",
        readOnly: true,
        required: true,
      },
      {
        translationsList: true,
      },
      {
        fieldName: "name",
        displayName: "Nombre",
        widget: "input",
        translated: true,
        required: true,
      },
      {
        fieldName: "htmlCancellation",
        displayName: "Cancelaciones / Pago por adelantado",
        widget: "richHTMLEditor",
        translated: true,
        required: true,
      },
      {
        fieldName: "htmlCheckIn",
        displayName: "Hora check-in",
        widget: "richHTMLEditor",
        translated: true,
        advancedTranslation: true,
        visible: ({ showAdvancedTranslations }) => showAdvancedTranslations,
      },
      {
        fieldName: "htmlCheckOut",
        displayName: "Hora check-out",
        widget: "richHTMLEditor",
        translated: true,
        visible: ({ showAdvancedTranslations }) => showAdvancedTranslations,
      },
      {
        fieldName: "htmlChildren",
        displayName: "Niños y camas supletorias",
        widget: "richHTMLEditor",
        translated: true,
        advancedTranslation: true,
        visible: ({ showAdvancedTranslations }) => showAdvancedTranslations,
      },
      {
        fieldName: "htmlPets",
        displayName: "Mascotas",
        widget: "richHTMLEditor",
        translated: true,
        visible: ({ showAdvancedTranslations }) => showAdvancedTranslations,
      },
      {
        fieldName: "htmlGroups",
        displayName: "Grupos",
        widget: "richHTMLEditor",
        translated: true,
        visible: ({ showAdvancedTranslations }) => showAdvancedTranslations,
      },
      {
        fieldName: "htmlExtraInfo",
        displayName: "Más información",
        widget: "richHTMLEditor",
        translated: true,
        visible: ({ showAdvancedTranslations }) => showAdvancedTranslations,
      },
      {
        fieldName: "color",
        displayName: "Color",
        widget: "colorPicker",
        defaultValue: "#908f96",
      },
      {
        fieldName: "payments",
        displayName: "Formas de cobro",
        defaultValue: [],
        selectables: true,
        selectAllText: "Select all",
        selectNoneText: "Select none",
        widget: "multicheckbox",
        multiCheckboxType: "LIST",
        entity: "paymentTypes",
        entityDisplay: "type",
        entitySecondaryDisplay: "title",
        entitySecondaryDisplayTranslated: true,
        entityKey: "type",
        fetch: true,
        required: true,
        mapping: {
          es: {
            CREDIT_CARD_VAULT: "Tarjeta como garantía",
            POS: "TPV",
            TRANSFER: "Transferencia",
            WITHOUT_CARD: "Reserva sin tarjeta",
            RESERVATION_REQUEST: "Solicitud de reserva",
            PNP_TOKEN: "Pago Tokenizado PNP",
            PAY_NO_PAIN_V2: PAYMENT_TYPES_NAMES.es.PAY_NO_PAIN_V2,
            SIPAY_TOKENIZED_VAULT: "Pago Tokenizado PNP",
            SIPAY_TOKENIZED_POS: "Pago Tokenizado PNP",
            PAYPAL_EXPRESS_CHECKOUT: "PayPal",
            PAYPAL_EXPRESS_STANDARD: "PayPal",
            STRIPE: "Stripe",
            PCI_PROXY: "PCI Proxy",
            ADDON_PAYMENTS: "Addon payment",
            DEFERRED: "Pago diferido",
            CRIPTAN: "Criptan",
            PAY_NO_PAIN_PROXY: "TC Garantía (PCI)",
            NEMURU: "Nemuru",
          },
          en: {
            CREDIT_CARD_VAULT: "Credit Card as a Guarantee",
            POS: "TPV",
            TRANSFER: "Wire Transfer",
            WITHOUT_CARD: "No credit card needed",
            RESERVATION_REQUEST: "Booking request",
            PNP_TOKEN: "Tokenized payment PNP",
            PAY_NO_PAIN_V2: PAYMENT_TYPES_NAMES.en.PAY_NO_PAIN_V2,
            SIPAY_TOKENIZED_VAULT: "Tokenized payment PNP",
            SIPAY_TOKENIZED_POS: "Tokenized payment PNP",
            PAYPAL_EXPRESS_CHECKOUT: "PayPal",
            PAYPAL_EXPRESS_STANDARD: "PayPal",
            STRIPE: "Stripe",
            PCI_PROXY: "PCI Proxy",
            ADDON_PAYMENTS: "Addon payment",
            DEFERRED: "Deferred payment",
            CRIPTAN: "Criptan",
            PAY_NO_PAIN_PROXY: "CC Guarantee (PCI)",
            NEMURU: "Nemuru",
          },
        },
      },
      {
        fieldName: "earlyCharge",
        displayName: "% cobro anticipado",
        widget: "input",
        defaultValue: 0,
        required: true,
      },
      {
        fieldName: "minimumCharge",
        displayName: "Cobro mínimo",
        widget: "input",
        defaultValue: 0,
        required: true,
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Cobrar primera noche",
        widget: "singleSwitch",
        defaultValue: false,
      },
      {
        fieldName: "policies",
        displayName: "Políticas de cancelación",
        defaultValue: [],
        selectables: true,
        selectAllText: "Select all",
        selectNoneText: "Select none",
        widget: "multicheckbox",
        entity: "cancellationPolicy",
        entityDisplay: "ticker",
        entityKey: "ticker",
        fetch: true,
        required: true,
      },
    ],
  },
  validation: {
    ticker: {
      ...tickerValidator,
      constraints: {
        ...tickerValidator.constraints,
        length: { maximum: 25, message: <FormattedMessage {...messages.tickerLengthValidation} /> },
      },
    },
    propertyTicker: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    color: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    payments: {
      type: "Array",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    earlyCharge: {
      type: "Number",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    minimumCharge: {
      type: "Number",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    chargeFirstNight: {},
    ordering: {
      type: "Number",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    policies: {
      type: "Array",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    name: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    htmlCancellation: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
